module.exports = require('./bit-json');
